import { call, put, takeEvery } from "redux-saga/effects";
import Constants from "../../Action/Constants";
import { ErrorHandlerSequence } from "../Sequences/ErrorHandlerSequence";
import { ActionInterface } from "../../Interface/ActionInterface";
import { CompanyInterface } from "../../Entity/Entities/Company/CompanyInterface";
import Translator from "../../Translation/Translator";
import Http from "../../Http/Http";

export default function* companyDelete(action: ActionInterface): any {
  try {
    yield put({
      type: Constants.GLOBAL_COMPANY_DELETE_REQUEST
    });

    yield call(Http.delete, `company/${action.payload?.company.id}`);

    const company: CompanyInterface = action.payload?.company.reinitialize({
      removed: true
    });

    yield put({
      type: Constants.GLOBAL_COMPANY_DELETE_SUCCESS,
      payload: {
        company: company
      }
    });

    yield put({
      type: Constants.SNACKBAR_ADD_MESSAGE,
      payload: {
        message: Translator.trans("snackbar-message-company-removed-successfully"),
        type: "success"
      }
    });

    if (action.hasOwnProperty("onSuccess") === true) {
      action.onSuccess.call(this, company);
    }

    yield put({
      type: Constants.PAGE_CONTACTS_SWITCH_TAB,
      payload: {
        index: 1
      }
    });
  } catch (err) {
    yield ErrorHandlerSequence(err, action);
  }
}

export function* watchCompanyDelete() {
  yield takeEvery(Constants.GLOBAL_COMPANY_DELETE_START, companyDelete);
}
